import { render } from "./jqzysjDetail.vue?vue&type=template&id=274e782d&scoped=true&ts=true"
import script from "./jqzysjDetail.vue?vue&type=script&lang=ts"
export * from "./jqzysjDetail.vue?vue&type=script&lang=ts"

import "./jqzysjDetail.vue?vue&type=style&index=0&id=274e782d&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274e782d"]])

export default __exports__